import React from 'react'
// import { withRouter } from 'react-router-dom'
// import { toJS } from 'mobx'
import { inject, observer } from 'mobx-react'
import { graphql } from 'react-apollo'
import _get from 'lodash/get'
import _flatten from 'lodash/flatten'
import _entries from 'lodash/entries'
import moment from 'moment'
import { Checkbox, Progress, Tooltip, Button, Radio, Form, Input, InputNumber, Tabs, Modal, Icon } from 'antd'
import CatchmentControl from '~/components/CatchmentControl'
// import DataTypeControl from '~/components/DataTypeControl'
import StationControl from './StationControl'

// import ResponseDataChart from './ResponseDataChart'
import { Section, ControlSection, ChartSection } from '~/components/styles'
// import categoriesQuery from '~/graphql/queries/categories.gql'
import scenariosQuery from '~/graphql/queries/scenarios.gql'
import forcingLocationsQuery from '~/graphql/queries/forcingLocations.gql'
import flowPatternsQuery from '~/graphql/queries/flowPatterns.gql'
import addScenarioMutation from '~/graphql/mutations/addScenario.gql'
import removeScenarioMutation from '~/graphql/mutations/removeScenario.gql'
import poisQuery from '~/graphql/queries/pois.gql'
// import user from '~/user.json'
import SalinityDataChart from './SalinityDataChart'
import FlocDataChart from './FlocDataChart'
import ForcingDataChart from './ForcingDataChart'
import config from '~/config'

const categoryConfig = _get(config, 'app.categories', []).find(cat => cat.name === 'สภาพน้ำทะเลหนุน')
// const { categories } = config.app
const SALINITY = _get(config, 'app.parameters', []).find(p => p.name === 'ความเค็ม')
const FLOW = _get(config, 'app.categories', []).find(p => p.name === 'อัตราการระบายน้ำ')
const TIDE = _get(config, 'app.categories', []).find(p => p.name === 'สภาพน้ำทะเลหนุน')
const MAX_SCENARIOS = 2
@inject('view')
@inject('data')
@inject('user')
@Form.create()
@graphql(scenariosQuery, {
  name: 'scenarios',
  props: ({
    scenarios: {
      loading,
      scenarios,
      refetch
    }
  }) => ({
    scenariosLoading: loading,
    scenariosRefetch: refetch,
    scenarios: _get(scenarios, 'nodes', [])
  }),
  options: ({ user: { profile } }) => ({
    variables: {
      userId: profile.userId
    }
  })
})
@graphql(forcingLocationsQuery, {
  name: 'flocs',
  props: ({
    flocs: {
      loading,
      forcingLocations,
      refetch
    }
  }) => ({
    flocsLoading: loading,
    flocsRefetch: refetch,
    flocs: _get(forcingLocations, 'nodes', [])
  })
})
@graphql(flowPatternsQuery, {
  name: 'flowPatterns',
  props: ({
    flowPatterns: {
      loading,
      flowPatterns,
      refetch
    }
  }) => ({
    flowPatternsLoading: loading,
    flowPatternsRefetch: refetch,
    flowPatterns: _get(flowPatterns, 'nodes', [])
  })
})
@graphql(poisQuery, {
  props: ({ data: { loading, pois, refetch } }) => ({
    loading,
    refetch,
    pois: _get(pois, 'nodes', [])
  }),
  options: ({ user: { profile } }) => ({
    variables: {
      userId: profile.userId
    }
  })
})
@graphql(addScenarioMutation, { name: 'addScenario' })
@graphql(removeScenarioMutation, { name: 'removeScenario' })
@observer
class Controls extends React.Component {
  state = {
    showModal: false
  }
  handleShowModal = () => {
    this.setState({
      showModal: true
    })
  }
  handleHideModal = () => {
    this.setState({
      showModal: false
    })
  }

  handleAddScenario = () => {
    const { form, addScenario } = this.props
    form.validateFields((err, data) => {
      if (err) {
        return console.error(err)
      }
      const { input } = data
      const { scenario, settings, outputs = [] } = input
      // console.log({ input })
      addScenario({
        variables: {
          scenario,
          settings,
          outputs: outputs.map(output => JSON.parse(output))
        },
        refetchQueries: [{
          query: scenariosQuery
        }]
      }).then(({ data }) => {
        this.setState({ showModal: false })
        form.resetFields()
      })
    })
  }

  handleScenarioChange = (values) => {
    const { view } = this.props
    if (values.length <= MAX_SCENARIOS) {
      view.setScenarioIds(values)
    }
  }

  handleConfirmRemoveScenario = (scenario) => {
    Modal.confirm({
      title: `ลบ scenario ${scenario.name}`,
      // content: 'When clicked the OK button, this dialog will be closed after 1 second',
      onOk: () => this.handleRemoveScenario(scenario.id),
      onCancel () {}
    })
  }

  handleRemoveScenario = (scenarioId) => {
    const { removeScenario } = this.props
    //    console.log({ scenariosQuery })
    window.location.reload();
    return removeScenario({
      variables: {
        id: scenarioId,
      },
      refetchQueries: [{
        query: scenariosQuery
      }]
    })
  }

  handleFlocChange = (values) => {
    const { view } = this.props
    view.setFlocIds(values)
  }
  render () {
    const { scenarios, flocs, flowPatterns, pois, form,
      view: { scenarioIds, flocIds, dataTypeIds, stationIds, poiIds },
      data: { now, stations = [],
        scenariosSalinityData: $scenariosSalinityData,
        scenariosFlocData: $scenariosFlocData,
        scenarioForcingData: $scenarioForcingData
      },
      user: { profile }
    } = this.props
    const today = moment(now).clone().set({ hour: 0, minute: 0, second: 0 })
    const { getFieldDecorator, getFieldValue, isFieldTouched } = form
    const scIds = scenarioIds ? scenarioIds.toJS() : []
    // console.log({ scenarios })
    // console.log({ profile })
    const typeNameMaps = {}
    stations.forEach(station => {
      typeNameMaps[`s${station.id}`] = station.stationName
    })
    pois.forEach(poi => {
      typeNameMaps[`p${poi.id}`] = poi.poiName
    })
    const flocNameMaps = {}
    flocs.forEach(floc => {
      flocNameMaps[floc.id] = floc.name
    })
    const scenariosSalinityData = $scenariosSalinityData.get()
    const $salinityData = () => {
      const data = _flatten(_flatten(
        _entries(scenariosSalinityData).map(([scenarioId, stationsData]) => {
          const scenario = scenarios.find(sc => sc.id === parseInt(scenarioId, 10))
          return _entries(stationsData)
            .filter(([spId]) =>
              spId.startsWith('s')
                ? stationIds.includes(parseInt(spId.substr(1), 10))
                : poiIds.includes(parseInt(spId.substr(1), 10))
            )
            .map(([spId, salinityData]) => {
              return salinityData.map(
                d => ({ ...d,
                  typeName: `${scenario.name}\n(${typeNameMaps[spId]})`
                })
              )
            })
        })
      ))
      if (data.length === 0) {
        return <div style={{ width: '100%', color: 'black' }}></div>
      }
      // const salinityDataTypeIds = dataTypeIds.response.get(category.id)
      // if (!salinityData || !salinityData[category.id]) {
      //   return <div style={{ width: '100%', color: 'black' }}></div>
      // }
      // const salinityDataTypeIds = dataTypeIds.response.get(category.id).toJS()
      // const data = _flatten(
      //   _entries(salinityData[category.id]).map(([stationId, stationData]) => {
      //     return _flatten(stationData).map(
      //       d => ({ ...d, typeName: stationId, type: d.type })
      //     )
      //   })
      // )
      // const data = _flatten(responseData[category.id]).map(
      //   d => ({ ...d, typeName: d.type.name })
      // )
      return <SalinityDataChart dataRecords={data} today={today} />
    }

    const scenariosFlocData = $scenariosFlocData.get()
    const $flocData = () => {
      const data = _flatten(_flatten(
        _entries(scenariosFlocData).map(([scenarioId, flocsData]) => {
          const scenario = scenarios.find(sc => sc.id === parseInt(scenarioId, 10))
          if (!scenario) {
            return []
          }
          return _entries(flocsData).map(([flocId, flocData]) => {
            return flocData.map(
              d => ({ ...d,
                typeName: `${scenario.name}\n(${flocNameMaps[flocId]})`
              })
            )
          })
        })
      ))
      if (data.length === 0) {
        return <div style={{ width: '100%', color: 'black' }}></div>
      }
      return <FlocDataChart dataRecords={data} today={today} />
    }

    const forcingData = $scenarioForcingData.get()
    const $forcingDataChart = () => {
      const forcingDataTypeIds = dataTypeIds.forcing.get(categoryConfig.id)
      if (!forcingData) {
        return <div style={{ width: '100%' }}></div>
      }
      // const forcingDataTypeIds = dataTypeIds.forcing.get(categoryConfig.id).toJS()
      const data = _flatten(forcingData).map(
        d => ({ ...d, typeName: _get(d, 'type.name') })
      )
      return <ForcingDataChart dataRecords={data} dataTypeIds={forcingDataTypeIds} categoryConfig={categoryConfig} today={today} />
    }
    getFieldDecorator('input.scenario.userId', {
      initialValue: profile.userId
    })

    return <div>
      <Section>
        <CatchmentControl title="ลุ่มน้ำ" />
        <ControlSection>
          <Checkbox.Group
            onChange={this.handleScenarioChange}
            value={scIds.map(JSON.stringify)}
          >
            {scenarios && scenarios.map(scenario =>
              <div key={scenario.id}>
                <Tooltip title={`${scenario.name} (${(scenario.progress || 0).toFixed(2)}%)`} placement="right">
                  <Checkbox key={scenario.id} value={`${scenario.id}`} >
                    <span style={{
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      display: 'inline-block',
                      verticalAlign: 'middle',
                      width: 60
                    }}>{scenario.name}</span>
                        &nbsp;&nbsp;&nbsp;&nbsp;
                    <Progress percent={parseFloat((scenario.progress || 0).toFixed(2))} size="small" style={{ width: '20px' }} showInfo={false} />
                    <Button icon="delete" size="small" shape="circle" style={{ marginLeft: 6 }} onClick={() => this.handleConfirmRemoveScenario(scenario)}/>
                  </Checkbox>
                </Tooltip>
              </div>
            )}
          </Checkbox.Group>
        </ControlSection>
        <ChartSection key={`chart`} style={{ marginTop: '-44px' }}>
          <div className="chartTitle">{SALINITY.name} ({SALINITY.unit})</div>
          {$salinityData()}
        </ChartSection>
      </Section>
      <Section>
        <StationControl title="สถานี" />
        <ChartSection key={`chart`}>
          <div className="chartTitle">{FLOW.name} ({FLOW.unit})</div>
          {$flocData()}
        </ChartSection>
      </Section>
      <Section>
        <ControlSection>
              จุดปล่อยน้ำ
          <Checkbox.Group
            onChange={this.handleFlocChange}
            value={flocIds.map(JSON.stringify)}
          >
            {flocs && flocs.map(floc =>
              <div key={floc.id}>
                <Checkbox key={floc.id} value={`${floc.id}`} >
                  {floc.name}
                </Checkbox>
              </div>
            )}
          </Checkbox.Group>
        </ControlSection>
        <ChartSection key={`chart`}>
          <div className="chartTitle">{TIDE.name} ({TIDE.unit})</div>
          {$forcingDataChart()}
        </ChartSection>
      </Section>
      <Section>
        <ControlSection>
          <Button onClick={this.handleShowModal} style={{ width: '100%' }}>Add Scenario</Button>
        </ControlSection>
        <Modal visible={this.state.showModal} onCancel={this.handleHideModal} width={600} onOk={this.handleAddScenario}>
          <Form layout="inline">
            <Form.Item style={{ display: 'block' }} label="ชื่อ">
              {getFieldDecorator('input.scenario.name', {
                rules: [{ required: true }]
              })(
                <Input style={{ width: 200 }} />
              )}
            </Form.Item>
            <Tabs tabPosition="left">
              {flocs && flocs.map((floc, flocIndex) => {
                const flowPatternDecorator = getFieldDecorator(`input.settings[${flocIndex}].flowPatternId`, {
                  rules: [{ required: true }]
                })
                const flowPatternId = getFieldValue(`input.settings[${flocIndex}].flowPatternId`)
                const flowSettingsFields = ({
                  2: [`input.settings[${flocIndex}].minVolume`],
                  3: [
                    `input.settings[${flocIndex}].minDuration`, `input.settings[${flocIndex}].maxDuration`,
                    `input.settings[${flocIndex}].minVolume`, `input.settings[${flocIndex}].maxVolume`
                  ],
                  4: [
                    `input.settings[${flocIndex}].minDuration`, `input.settings[${flocIndex}].maxDuration`,
                    `input.settings[${flocIndex}].minVolume`, `input.settings[${flocIndex}].maxVolume`
                  ]
                })[flowPatternId] || []
                getFieldDecorator(`input.settings[${flocIndex}].forcingLocationId`, {
                  initialValue: floc.id,
                  rules: [{ required: true }]
                })
                const $minVolume = getFieldDecorator(`input.settings[${flocIndex}].minVolume`, {
                  rules: [{ required: flowSettingsFields.includes(`input.settings[${flocIndex}].minVolume`) }]
                })(
                  <InputNumber min={0} max={4000} precision={2} style={{ width: 72 }}/>
                )
                const $maxVolume = getFieldDecorator(`input.settings[${flocIndex}].maxVolume`, {
                  rules: [{ required: flowSettingsFields.includes(`input.settings[${flocIndex}].maxVolume`) }]
                })(
                  <InputNumber min={0} max={4000} precision={2} style={{ width: 72 }}/>
                )
                const $minDuration = getFieldDecorator(`input.settings[${flocIndex}].minDuration`, {
                  rules: [{ required: flowSettingsFields.includes(`input.settings[${flocIndex}].minDuration`) }]
                })(
                  <InputNumber min={0} max={168} style={{ width: 60 }}/>
                )
                const $maxDuration = getFieldDecorator(`input.settings[${flocIndex}].maxDuration`, {
                  rules: [{ required: flowSettingsFields.includes(`input.settings[${flocIndex}].maxDuration`) }]
                })(
                  <InputNumber min={0} max={168} style={{ width: 60 }}/>
                )
                const settingsFields = [`input.settings[${flocIndex}].salinity`, `input.settings[${flocIndex}].flowPatternId`]
                const fieldsTouched = settingsFields.concat(flowSettingsFields).reduce((touched, field) => touched && isFieldTouched(field), true)

                return <Tabs.TabPane
                  key={floc.id}
                  tab={<span>{floc.name} <Icon type={fieldsTouched ? 'check-circle' : 'close-circle-o'} /></span>}
                >
                  <Form.Item style={{ display: 'block' }} label="ความเค็ม">
                    {getFieldDecorator(`input.settings[${flocIndex}].salinity`, {
                      // initialValue: 0
                      rules: [{ required: true }]
                    })(
                      <InputNumber min={0} max={35} precision={2} />
                    )}
                    &nbsp;g/L
                  </Form.Item>
                  <Form.Item style={{ display: 'block' }}>
                    {flowPatternDecorator(
                      <Radio.Group>
                        {flowPatterns && flowPatterns.map(pattern =>
                          <Radio key={pattern.id} value={pattern.id} style={{ display: 'block' }}>{pattern.name}</Radio>
                        )}
                      </Radio.Group>
                    )}
                  </Form.Item>
                  {{
                    2: <Form.Item style={{ display: 'block' }}>อัตราการระบายน้ำ {$minVolume} m³/s</Form.Item>,
                    3: <Form.Item style={{ display: 'block' }}>
                      ค่าสูงสุด {$maxVolume} m³/s เป็นเวลา {$maxDuration} ชม. <br />
                      ค่าต่ำสุด {$minVolume} m³/s เป็นเวลา {$minDuration} ชม. <br />
                    </Form.Item>,
                    4: <Form.Item style={{ display: 'block' }}>
                      ค่าต่ำสุด {$minVolume} m³/s เป็นเวลา {$minDuration} ชม. <br />
                      ค่าสูงสุด {$maxVolume} m³/s เป็นเวลา {$maxDuration} ชม. <br />
                    </Form.Item>
                  }[flowPatternId]}
                </Tabs.TabPane>
              })}
            </Tabs>
            <Form.Item style={{ display: 'block' }}>
              {getFieldDecorator('input.outputs')(
                <Checkbox.Group
                // options={parameters}
                // onChange={this.handleStationChange}
                // defaultValue={dataTypes.filter(dt => dt.default).map(dt => `${dt.id}`)}
                // value={sIds.map(JSON.stringify)}
                >
                  {stations.filter(station => station.isResponseData).map(station =>
                    <div key={`sId:${station.id}`}>
                      <Checkbox value={
                        JSON.stringify({
                          isPoi: false,
                          stationPoiId: station.id
                        })
                      }>
                        {station.stationName}
                      </Checkbox>
                    </div>
                  )}
                  {pois && pois.map(poi =>
                    <div key={`pId:${poi.id}`}>
                      <Checkbox key={poi.id} value={
                        JSON.stringify({
                          isPoi: true,
                          stationPoiId: poi.id
                        })
                      }>
                        {poi.poiName}
                      </Checkbox>
                    </div>
                  )}
                </Checkbox.Group>
              )}
            </Form.Item>
          </Form>
        </Modal>
      </Section>
    </div>
  }
}

export default Controls



// WEBPACK FOOTER //
// ./src/modules/Scenario/Controls.js